// src/components/TableView.js
export class TableView {
    constructor(selector, data) {
        this.selector = selector;
        this.data = data;
        this.container = document.querySelector(selector);
        this.sortedData = [...data];
        this.currentSortColumn = '';
        this.isAscending = true;
    }

    render() {
        if (!this.data || this.data.length === 0) {
            this.container.innerHTML = '<div class="error">Нет данных для отображения</div>';
            return;
        }

        this.container.innerHTML = this.createTable();
        this.setupEventListeners();
    }

    createTable() {
        return `
            <div class="table-wrapper">
                <table class="employees-table">
                    <thead>
                        <tr>
                            <th data-column="index">№ <span class="sort-icon"></span></th>
                            <th data-column="image">Фото</th>
                            <th data-column="name">Имя <span class="sort-icon"></span></th>
                            <th data-column="positionname">Должность <span class="sort-icon"></span></th>
                            <th data-column="birth_date">Дата рождения <span class="sort-icon"></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        ${this.sortedData.map((employee, index) => this.createTableRow(employee, index)).join('')}
                    </tbody>
                </table>
            </div>
        `;
    }

    createTableRow(employee, index) {
        return `
            <tr data-id="${employee.id}">
                <td>${index + 1}</td>
                <td>
                    <div class="node-avatar" style="background-image: url('${employee.imageurl}'); width: 40px; height: 40px; border-radius: 50%; background-size: cover; background-position: center; margin: 0 auto; cursor: ${employee.profileurl ? 'pointer' : 'default'};" onclick="window.open('${employee.profileurl || ''}', '_blank');">
                        ${!employee.imageurl ? `<span>${this.getInitials(employee.name)}</span>` : ''}
                    </div>
                </td>
                <td>${employee.name || 'Не указано'}</td>
                <td>${employee.positionname || 'Не указана'}</td>
                <td>${employee.birth_date ? new Date(employee.birth_date).toLocaleDateString('ru-RU') : 'Не указана'}</td>
            </tr>
        `;
    }

    getInitials(name) {
        if (!name) return '?';
        return name
            .split(' ')
            .slice(0, 2)
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase();
    }

    setupEventListeners() {
        const headers = this.container.querySelectorAll('th');
        headers.forEach(header => {
            header.addEventListener('click', () => {
                const column = header.getAttribute('data-column');
                this.sortTable(column);
            });
        });
    }

    sortTable(column) {
        if (this.currentSortColumn === column) {
            this.isAscending = !this.isAscending;
        } else {
            this.currentSortColumn = column;
            this.isAscending = true;
        }

        this.sortedData.sort((a, b) => {
            let valueA = a[column] || '';
            let valueB = b[column] || '';
            
            if (column === 'birth_date') {
                valueA = valueA ? new Date(valueA).getTime() : 0;
                valueB = valueB ? new Date(valueB).getTime() : 0;
            } else if (column === 'index') {
                valueA = this.sortedData.indexOf(a);
                valueB = this.sortedData.indexOf(b);
            } else {
                valueA = valueA.toString().toLowerCase();
                valueB = valueB.toString().toLowerCase();
            }

            if (valueA < valueB) return this.isAscending ? -1 : 1;
            if (valueA > valueB) return this.isAscending ? 1 : -1;
            return 0;
        });

        this.render();
    }

    updateData(newData) {
        this.data = newData;
        this.sortedData = [...newData];
        this.render();
    }
}
